"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var ButtonGroup = {
  styles: function styles(theme) {
    return {
      label: {
        color: theme.colors.baseContrast085,
        fontSize: theme.typography.fontSize,
        fontWeight: 600,
        textTransform: "uppercase",
        marginBottom: 2,
        marginInlineStart: 2
      },
      wrapper: {
        borderRadius: 7,
        textTransform: "capitalize",
        borderColor: theme.colors.baseContrast040
      },
      hint: {
        marginInlineStart: theme.spacing.base / 2,
        textTransform: "initial",
        color: theme.colors.baseContrast085
      },
      description: {
        textTransform: "initial",
        color: theme.colors.baseContrast085
      }
    };
  }
};
var _default = exports.default = ButtonGroup;